<template>
	<div id="spinner">
		<span class="icon fa fa-spinner"></span>
	</div>
</template>

<script>
	export default {
		name: 'Spinner',
	};
</script>

<style lang="scss" scoped>
	body {
		#spinner {
			z-index: 5000;
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.15);
			.icon {
				position: absolute;
				top: 50%;
				left: 50%;
				margin: -25px 0 0 -25px;
				width: 50px;
				height: 50px;
				color: $font-blue;
				font-size: 50px;
				animation-name: rolling;
				animation-duration: 2s;
				animation-iteration-count: infinite;
				animation-timing-function: linear;
			}
		}
	}
	@keyframes rolling {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
</style>
